import { useSelector } from "react-redux";
import { RootState } from "../../store";

export default function useFeaturePermission(featureId?: number) {
  const features = useSelector((state: RootState) => state.access.features);

  if (!featureId) {
    return {
      canView: true,
      canEdit: true,
    };
  }

  const feature = features.find((f) => f.featuresId === featureId);

  return {
    canView: !!feature?.active,
    canEdit: !!feature?.active && !!feature?.canEdit,
  };
}
